import { listAllTherapistPatientsResponse } from "./patients";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { useCourseLabels } from "../../center";

import { Patient } from "../domain/Patient";

export interface PatientOption {
    value: string;
    label: string;
    firstName: string;
    heldByCenter: boolean;
}

/** The therapist's individual patients, as choices for a couple or a group. */
export function usePatientOptions(therapistId: string | undefined) {
    // A training centre's student is named with the course they are on.
    const { labelOf } = useCourseLabels();
    const { data, isLoading } = useQuery({
        queryKey: ["patient-options", therapistId],
        queryFn: async () => {
            const response = await listAllTherapistPatientsResponse(therapistId as string);
            return (response.data.patients ?? []) as Patient[];
        },
        enabled: Boolean(therapistId),
    });
    const options = useMemo(
        () =>
            (data ?? []).map(
                (patient): PatientOption => ({
                    value: patient.id,
                    label: labelOf(patient),
                    firstName: patient.first_name,
                    heldByCenter: Boolean(patient.center_id),
                })
            ),
        [data, labelOf]
    );
    return { options, loading: isLoading };
}
